const messages: Record<string, [string, string, string]> = {
  title: ['业务预设补缺', '業務預設補缺', 'Preset synchronization'],
  description: [
    '只补缺少的预设，保留本会已有配置。',
    '只補缺少的預設，保留本會已有配置。',
    'Add missing presets and retain existing configuration.',
  ],
  preview: ['预览缺项', '預覽缺項', 'Preview missing items'],
  execute: ['执行补缺', '執行補缺', 'Synchronize'],
  refresh: ['刷新状态', '重新整理狀態', 'Refresh status'],
  resume: ['继续原任务', '繼續原任務', 'Resume task'],
  readFailed: [
    '状态读取失败，请重试。',
    '狀態讀取失敗，請重試。',
    'Unable to read task status. Retry.',
  ],
  previewFailed: [
    '预览失败，请核对错误后重试。',
    '預覽失敗，請核對錯誤後重試。',
    'Preview failed. Resolve the error and retry.',
  ],
  actionFailed: [
    '执行结果未确认，请刷新状态。',
    '執行結果未確認，請重新整理狀態。',
    'Result unconfirmed. Refresh task status.',
  ],
  domain: ['范围', '範圍', 'Scope'],
  source: ['平台来源数', '平台來源數', 'Source count'],
  existing: ['本会已有', '本會已有', 'Existing'],
  missing: ['待新增', '待新增', 'Missing'],
  protected: ['保留本会设置', '保留本會設定', 'Protected'],
  created: ['本次新增', '本次新增', 'Created'],
  sourceUnit: ['来源单位', '來源單位', 'Source unit'],
  operation: ['任务号', '任務號', 'Task ID'],
  phase: ['当前阶段', '目前階段', 'Current stage'],
  errorCode: ['错误码', '錯誤碼', 'Error code'],
  'status.running': ['执行中', '執行中', 'Running'],
  'status.succeeded': ['已完成', '已完成', 'Completed'],
  'status.failed': ['未完成', '未完成', 'Failed'],
  'status.core_ready': [
    '核心就绪，尚未全部完成',
    '核心就緒，尚未全部完成',
    'Core ready; synchronization incomplete',
  ],
  'phase.prepare': ['准备', '準備', 'Preparing'],
  'phase.platform': ['平台配置', '平台配置', 'Platform'],
  'phase.content': ['内容与官网', '內容與官網', 'Content and website'],
  'phase.iam': ['权限', '權限', 'Permissions'],
  'phase.iamPreset': ['权限', '權限', 'Permissions'],
  'phase.member': ['会员配置', '會員配置', 'Membership'],
  'phase.notify': ['通知', '通知', 'Notifications'],
  'phase.billing': ['计费', '計費', 'Billing'],
  'phase.translations': ['补齐译文', '補齊譯文', 'Translations'],
  'phase.contentFormPublish': [
    '发布新增表单',
    '發佈新增表單',
    'Publish new forms',
  ],
  'phase.core_ready': [
    '核心配置就绪',
    '核心配置就緒',
    'Core configuration ready',
  ],
  'phase.complete': ['已完成', '已完成', 'Completed'],
  'domain.platform': ['平台', '平台', 'Platform'],
  'domain.content': ['内容与官网', '內容與官網', 'Content and website'],
  'domain.iam': ['权限', '權限', 'Permissions'],
  'domain.member': ['会员', '會員', 'Membership'],
  'domain.notify': ['通知', '通知', 'Notifications'],
  'domain.billing': ['计费', '計費', 'Billing'],
  'unit.row': ['条目', '條目', 'Entries'],
  'unit.key': ['配置键', '配置鍵', 'Configuration keys'],
  'unit.configuration_key': ['配置键', '配置鍵', 'Configuration keys'],
  'unit.definition': ['定义', '定義', 'Definitions'],
  'unit.template': ['模板', '範本', 'Templates'],
  'family.plat_sport': ['运动项目', '運動項目', 'Sports'],
  'family.plat_club_kind': ['属会类型', '屬會類型', 'Club types'],
  'family.member_right_word': ['权利词库', '權利詞庫', 'Rights'],
  'family.member_member_type': ['会员类型', '會員類型', 'Member types'],
  'family.member_member_type_right': [
    '会员类型权利',
    '會員類型權利',
    'Member type rights',
  ],
  'family.member_qual_type': [
    '注册身份类型',
    '註冊身份類型',
    'Registration types',
  ],
  'family.member_qual_type_right': [
    '注册身份权利',
    '註冊身份權利',
    'Registration rights',
  ],
  'family.member_qual_type_sport': [
    '注册身份运动项目',
    '註冊身份運動項目',
    'Registration sports',
  ],
  'family.member_club_level': ['属会等级', '屬會等級', 'Club levels'],
  'family.member_club_level_right': [
    '属会等级权利',
    '屬會等級權利',
    'Club level rights',
  ],
  'family.member_club_level_kind': [
    '属会等级准入',
    '屬會等級准入',
    'Club level eligibility',
  ],
  'family.member_club_doc_lib': ['属会资料库', '屬會資料庫', 'Club documents'],
  'family.member_club_level_doc': [
    '属会等级资料要求',
    '屬會等級資料要求',
    'Club document requirements',
  ],
  'family.flow_application_type_step': ['审核环节', '審核環節', 'Review steps'],
  'family.iam_post': ['岗位', '崗位', 'Posts'],
  'family.iam_department': ['部门', '部門', 'Departments'],
  'family.iam_position': ['职位', '職位', 'Positions'],
  'family.iam_permission_package': ['权限包', '權限包', 'Permission packages'],
  'family.msg_notify_type': ['通知类型', '通知類型', 'Notification types'],
  'family.msg_template': ['消息模板', '訊息範本', 'Message templates'],
  'family.fin_trade_config': ['交易设置', '交易設定', 'Trade configuration'],
  'family.fin_receipt_config': [
    '收据设置',
    '收據設定',
    'Receipt configuration',
  ],
  'family.fin_order_type': ['订单类型', '訂單類型', 'Order types'],
  'family.fin_pay_channel_account': [
    '支付渠道',
    '支付渠道',
    'Payment channels',
  ],
  'family.dict': ['基础字典', '基礎字典', 'Dictionaries'],
  'family.cmtKind': ['委员类型', '委員類型', 'Committee member types'],
  'family.title': ['委员职务', '委員職務', 'Committee titles'],
  'family.committee': ['委员会', '委員會', 'Committees'],
  'family.fieldLib': ['字段库', '欄位庫', 'Field library'],
  'family.contentTemplate': ['内容模板', '內容範本', 'Content templates'],
  'family.form': ['标准表单', '標準表單', 'Standard forms'],
  'family.article': ['官网文章', '官網文章', 'Website articles'],
  'family.site': ['官网骨架', '官網骨架', 'Website structure'],
  'family.siteMenu': ['官网导航', '官網導覽', 'Website navigation'],
};

function forLanguage(index: 0 | 1 | 2): Record<string, string> {
  return Object.fromEntries(
    Object.entries(messages).map(([key, values]) => [
      `businessPreset.${key}`,
      values[index],
    ]),
  );
}

export const businessPresetsZhCN = forLanguage(0);
export const businessPresetsZhHK = forLanguage(1);
export const businessPresetsEnUS = forLanguage(2);
